export default {"src":"/_next/static/media/traded1.ee7de8d8.svg","height":42,"width":40};